export default __webpack_public_path__ + "static/media/sy.f9a09527.jpg";